import { checkPermission } from '@/utils/routeAuth'

/**
 * 根据按钮类型判断权限
 * @param btnType 按钮类型
 * @returns {boolean}
 */
export function checkAuth (btnType) {
  return checkPermission(`personPlan:${btnType}`)
}
